import React, { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getApiBaseUrl } from '../../../config/apiBase';

export default function StripeOffers() {
  const { getAccessTokenSilently, isAuthenticated, loginWithRedirect } = useAuth0();
  const [offers, setOffers] = useState([]), [busy, setBusy] = useState(false), [message, setMessage] = useState('');
  const keys = useRef({});
  useEffect(() => { fetch(`${getApiBaseUrl()}/api/group-finance/offers`).then(r => r.ok ? r.json() : []).then(setOffers).catch(() => setMessage('Card listings could not be loaded.')); }, []);
  const buy = async offer => {
    if (!isAuthenticated) return loginWithRedirect({ appState: { returnTo: '/marketplace' } });
    setBusy(true); setMessage('');
    try {
      keys.current[offer.assetId] ||= crypto.randomUUID();
      const token = await getAccessTokenSilently();
      const response = await fetch(`${getApiBaseUrl()}/api/group-finance/${offer.groupId}/checkout`, { method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ requestKey: keys.current[offer.assetId], assetId: offer.assetId, amount: 0 }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.detail || 'Item could not be purchased.');
      if (result.checkoutUrl) window.location.assign(result.checkoutUrl);
      else setMessage(`Order status: ${result.status}`);
    } catch (e) { setMessage(e.message); } finally { setBusy(false); }
  };
  if (!offers.length && !message) return null;
  return <section aria-label="Group items accepting card payments"><h2>Group items — pay by card</h2>
    <p>Payment goes to the selling group’s connected account. Manage delivery with the group; refunds are processed through Stripe.</p>
    {message && <p role="status">{message}</p>}
    {offers.map(offer => <article key={offer.assetId}><h3>{offer.assetName}</h3><p>{offer.assetDescription}</p>
      <button disabled={busy} onClick={() => buy(offer)}>{busy ? 'Opening checkout…' : `Buy for $${offer.price.toFixed(2)} USD`}</button>
    </article>)}
  </section>;
}
